import { defaultApi } from '@/plugins/api/defaultApi'
import { or } from 'vuelidate/lib/validators'

const defaultHost = process.env.common?.myfinbiz?.host || 'nice-factoring.funda.kr'

export default {
  name: 'myfinbiz',
  namespaced: true,
  state: {
    organization: null,
  },
  getters: {
    organization: (state) => state.organization,
    isDefaultPlatform({ organization }) {
      if (!organization) {
        return true
      }
      return organization.host.includes(defaultHost)
    },
    platformName({ organization }) {
      return organization?.name || '번개입금'
    },
    platformCode({ organization }) {
      console.log('organization', organization)
      return organization?.code || 'nice-factoring'
    },
    faviconUrl({ organization }) {
      if (!organization || !organization.code) {
        return '/favicon.ico' // 기본 파비콘
      }

      const customFaviconPath = `/${organization.code}.ico`

      // 파일 존재 여부를 확인하는 함수
      const fileExists = (url) => {
        const http = new XMLHttpRequest()
        http.open('HEAD', url, false)
        http.send()
        return http.status !== 404
      }

      // 커스텀 파비콘이 존재하면 사용, 아니면 기본 파비콘 사용
      return fileExists(customFaviconPath) ? customFaviconPath : '/favicon.ico'
    },
    getOrganization: (state) => state.organization,
  },
  mutations: {
    setOrganization(state, organization) {
      state.organization = organization
    },
  },
  actions: {
    async init({ commit, dispatch }, host) {
      if (host.startsWith('localhost')) {
        host = defaultHost
        // 테스트 하고싶은 host를 넣어야함
        // host = 'poscodi.funda.kr'
        // host = 'jeonghoonkingpay.funda.kr'
        // host = 'pay-1.funda.kr'
        // host = 'hiddenpay.funda.kr'
        // host = 'baropay.funda.kr'
        // host = 'ssmnc.funda.kr'
      }

      try {
        console.log('host=', host)
        // 1차: organizations 조회
        const { data } = await defaultApi.getMyfinbizOrganizationsByHost(host)

        if (data && data.length > 0) {
          // organizations 데이터가 있는 경우
          const [organization] = data
          let code = organization?.code

          const myfinbizOrganizationCode = localStorage.getItem('myfinbizOrganizationCode')
          if (myfinbizOrganizationCode) {
            code = myfinbizOrganizationCode
          }

          await dispatch('processOrganization', { organization, code })
        } else {
          // 2차: organization agencies 조회
          const { data: agencyData } = await defaultApi.getMyfinbizOrganizationAgenciesByHost(host)

          if (agencyData && agencyData.length > 0) {
            const [agency] = agencyData
            const code = agency.code // agency의 code 사용
            const organization = agency.organization // 하위 organization 정보 사용

            await dispatch('processOrganization', { organization, code })
          }
        }
      } catch (e) {
        console.error('Failed to initialize organization:', e)
      }
    },

    // processOrganization을 별도 action으로 정의
    async processOrganization({ commit }, { organization, code }) {
      console.log('code=', code)
      await import(`@/assets/scss/myfinbiz/${code}.scss`)
      console.log('organization=', organization)

      if (!organization.banks || organization.banks.length === 0) {
        organization.banks = [
          {
            bank: '88',
          },
        ]
      }

      commit('setOrganization', organization)
    },

    organizationsAddCustomer({ state }) {
      return defaultApi.postMyfinbizOrganizationsAddCustomer(state.organization.uuid)
    },
    async getCustomerFeeSettingsCurrent() {
      const { data } = await defaultApi.getMyfinbizCustomerFeeSettingsCurrent()
      return data
    },
    async getContractsAgreementsMyfinbizService() {
      const { data } = await defaultApi.getContractsAgreementsMyfinbizService()
      return data
    },
  },
}
